package com.example.event_management_system.data.models

import kotlinx.serialization.Serializable

@Serializable
data class Section(
    val id: String = "",
    val name: String = "",
    val locationId: String = "",
    val isActive: Boolean = true
)
